import * as React from 'react'

export default function Footer() {
  return (
    <div>
      <p className="App-footer">
        Jos varauskalenterin kanssa tulee ongelmia ota yhteyttä hallitus (jat)
        jatti.fi
      </p>
      <p className="App-footer App-right">{'© T. Kaipiainen & E. Nauha'}</p>
    </div>
  )
}
